import React from "react";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";

import Introduzione from "views/index-sections/Introduzione.js";
import Testo1 from "views/index-sections/Testo1.js";
import Caratteristiche from "views/index-sections/Caratteristiche.js";
import Installazione from "views/index-sections/Installazione.js";
import CardPagine from "views/index-sections/CardPagine.js";
import CardProgetti from "views/index-sections/CardProgetti.js";
import Collegamenti from "views/index-sections/Collegamenti.js";

function Index() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("index");
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });
  return (
    <>
      {/* Navbar */}
      <IndexNavbar />

      {/* Header */}
      <IndexHeader />

      {/* inizio del contenuto */}
      <div className="main">
        <Introduzione />
        <Testo1 />
        <Caratteristiche />
        <Installazione />
        <CardPagine />
        <CardProgetti />
        <Collegamenti />
        {/* Footer */}
        <DemoFooter />
      </div>
      {/* Fine del contenuto */}
    </>
  );
}

export default Index;
